import { createEffect, sample } from 'effector';
import { createGate } from 'effector-react';
import { createQuery } from '@farfetched/core';
import { getResidentAccountStatus } from './api';
import type {
  GetResidentAccountStatusPayload,
  GetResidentAccountStatusResponse,
  Props,
} from './types';

export const ResidentAccountStatusControlGate = createGate<Props>();

const fxGetResidentAccountStatus = createEffect<
  GetResidentAccountStatusPayload,
  GetResidentAccountStatusResponse,
  Error
>().use(getResidentAccountStatus);

export const residentAccountStatusQuery = createQuery({
  name: 'resident-account-status',
  effect: fxGetResidentAccountStatus,
  mapData: ({ result }) => ({
    options: Array.isArray(result?.type_list)
      ? result.type_list.map((item) => ({
          id: item?.type,
          label: item?.title,
          message: item?.message,
        }))
      : [],
    helperText: result?.general_message ?? '',
  }),
});

sample({
  clock: ResidentAccountStatusControlGate.state,
  source: {
    status: ResidentAccountStatusControlGate.status,
    state: ResidentAccountStatusControlGate.state,
  },
  filter: ({ status, state: { accountId } }) => !!(status && accountId),
  fn: ({ state: { accountId } }) => ({
    personal_account_id: accountId!,
  }),
  target: residentAccountStatusQuery.start,
});

sample({
  clock: ResidentAccountStatusControlGate.close,
  target: residentAccountStatusQuery.reset,
});

sample({
  clock: residentAccountStatusQuery.finished.success,
  source: ResidentAccountStatusControlGate.status,
  filter: (isOpened) => !isOpened,
  target: residentAccountStatusQuery.reset,
});
